<template>
  <section class="context-capture">
    <h2>Context Capture</h2>
    <div class="context-desc">
      Extract and tag emails with project metadata automatically. This helps organize emails and track project information.
    </div>
    <div class="metadata-header">
      <span>Extracted Metadata</span>
      <button class="refresh-btn" @click="refreshMetadata">Refresh</button>
    </div>
    <div class="metadata-grid">
      <div class="metadata-card">
        <div class="metadata-title">
          <svg width="20" height="20" fill="none" stroke="#198754" stroke-width="2" style="vertical-align:middle;">
            <rect x="3" y="5" width="14" height="10" rx="2" stroke="#198754" stroke-width="2" fill="none"/>
            <path d="M3 7l7 5 7-5" stroke="#198754" stroke-width="2" fill="none"/>
          </svg>
          <span>File Information</span>
        </div>
        <div class="metadata-field">File ID<br><span class="metadata-value">{{ metadata.fileId || '-' }}</span></div>
        <div class="metadata-field">Property ID<br><span class="metadata-value">{{ metadata.propertyId || '-' }}</span></div>
      </div>
      <div class="metadata-card">
        <div class="metadata-title">
          <svg width="20" height="20" fill="none" stroke="#198754" stroke-width="2" style="vertical-align:middle;">
            <path d="M4 7h12M4 11h12M4 15h12" stroke="#198754" stroke-width="2"/>
            <circle cx="7" cy="7" r="1" fill="#198754"/>
            <circle cx="7" cy="11" r="1" fill="#198754"/>
            <circle cx="7" cy="15" r="1" fill="#198754"/>
          </svg>
          <span>Client Information</span>
        </div>
        <div class="metadata-field">Client Name<br><span class="metadata-value">{{ metadata.clientName || '-' }}</span></div>
        <div class="metadata-field">Appraiser<br><span class="metadata-value">{{ metadata.appraiser || '-' }}</span></div>
      </div>
      <div class="metadata-card">
        <div class="metadata-title">
          <svg width="20" height="20" fill="none" stroke="#198754" stroke-width="2" style="vertical-align:middle;">
            <rect x="4" y="7" width="12" height="8" rx="2" stroke="#198754" stroke-width="2"/>
            <path d="M4 11h12" stroke="#198754" stroke-width="2"/>
          </svg>
          <span>Property Details</span>
        </div>
        <div class="metadata-field">Property Name<br><span class="metadata-value">{{ metadata.propertyName || '-' }}</span></div>
        <div class="metadata-field">Property Address<br><span class="metadata-value">{{ metadata.propertyAddress || '-' }}</span></div>
      </div>
      <div class="metadata-card">
        <div class="metadata-title">
          <svg width="20" height="20" fill="none" stroke="#198754" stroke-width="2" style="vertical-align:middle;">
            <circle cx="10" cy="10" r="8" stroke="#198754" stroke-width="2"/>
            <path d="M10 6v4l3 2" stroke="#198754" stroke-width="2"/>
          </svg>
          <span>Project Status</span>
        </div>
        <div class="metadata-field">Status<br><span class="metadata-value">{{ metadata.status || '-' }}</span></div>
        <div class="metadata-field">Phase<br><span class="metadata-value">{{ metadata.phase || '-' }}</span></div>
      </div>
    </div>
    <div class="metadata-footer">
      Metadata extracted on {{ extractedAt }}
    </div>
    <div class="metadata-success">
      <svg width="18" height="18" fill="none" stroke="#198754" stroke-width="2" style="vertical-align:middle;">
        <circle cx="9" cy="9" r="8" stroke="#198754" stroke-width="2"/>
        <path d="M5 9l3 3 5-5" stroke="#198754" stroke-width="2"/>
      </svg>
      Metadata extraction completed successfully. This information will be used to organize and categorize this email.
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContextCapture',
  data() {
    return {
      metadata: {
        fileId: '',
        propertyId: 'P001',
        clientName: '',
        appraiser: '',
        propertyName: '',
        propertyAddress: '123 Main St',
        status: '',
        phase: ''
      },
      extractedAt: '6/30/2025, 11:56:12 AM'
    }
  },
  methods: {
    refreshMetadata() {
      // Add logic to re-extract metadata from email
      alert('Metadata refreshed!');
    }
  }
}
</script>

<style scoped>
.context-capture {
  background: #fff;
  border-radius: 10px;
  padding: 1.2rem 1.2rem 0.7rem 1.2rem;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
  border: 1px solid #e0e0e0;
}
.context-capture h2 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
.context-desc {
  color: #555;
  font-size: 14px;
  margin-bottom: 1.1rem;
}
.metadata-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.7rem;
}
.refresh-btn {
  background: none;
  border: none;
  color: #198754;
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}
.metadata-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.7rem;
}
.metadata-card {
  border-radius: 4px;
  padding: 0.9rem 1rem 0.7rem 1rem;
  border: 1px solid #e0e0e0;
  min-width: 180px;
}
.metadata-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 14px;
}
.metadata-field {
  color: #444;
  font-size: 12px;
  margin-bottom: 0.3rem;
}
.metadata-value {
  font-weight: 500;
  color: #222;
}
.metadata-footer {
  color: #888;
  font-size: 12px;
  margin-top: 0.5rem;
  margin-bottom: 0.7rem;
}
.metadata-success {
  color: #198754;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}
</style>